import { Chip } from "@mui/material"
import React, { type ReactElement } from "react"

import { Avatar } from "@/components/common/Avatar"

interface DisplayAS400IdProps {
  id?: string | number | null
  "data-testid"?: string
}

const DisplayAS400Id = ({ id, "data-testid": testId = "external-system-id" }: DisplayAS400IdProps): ReactElement => {
  return (
    <Chip
      label={id ?? "----"}
      className='h-6 rounded-[4px] bg-gray-300 text-xs text-gray-900'
      avatar={
        <Avatar size={40} className='h-4 w-12 rounded bg-gray-500 p-1 text-[10px] text-gray-900'>
          AS400
        </Avatar>
      }
      data-testid={testId}
    />
  )
}

export default DisplayAS400Id
